module.exports = __webpack_public_path__ + "img/works_wechat_anpi_1.81594acf.png";